import { ColDef } from 'ag-grid-community';
import { ServiceRole, SignatureAuthority } from 'pco-product-service-internal-consumer';
import i18n from '../../../../../i18n';
import { isSafeDepositBoxServiceRoleProperties } from '../../../productSpecificProperties';

const partnerTypeLabels: Record<string, string> = {
  INDIVIDUAL_PARTNER: 'PI',
  LEGAL_PARTNER: 'LE',
};

const signatureAuthorityLabels: Record<SignatureAuthority, string> = {
  [SignatureAuthority.Individual]: 'Individual',
  [SignatureAuthority.Collective2]: 'Collectively 2',
  [SignatureAuthority.Collective3]: 'Collectively 3',
  [SignatureAuthority.Collective4]: 'Collectively 4',
  [SignatureAuthority.Collective5]: 'Collectively 5',
  [SignatureAuthority.Collective6]: 'Collectively 6',
  [SignatureAuthority.Collective7]: 'Collectively 7',
  [SignatureAuthority.Collective8]: 'Collectively 8',
  [SignatureAuthority.Collective9]: 'Collectively 9',
  [SignatureAuthority.Collective10]: i18n.t('pb.safedepositbox.signatureauthority.collective', { count: 10 }),
  [SignatureAuthority.Collective11]: i18n.t('pb.safedepositbox.signatureauthority.collective', { count: 11 }),
  [SignatureAuthority.Collective12]: i18n.t('pb.safedepositbox.signatureauthority.collective', { count: 12 }),
  [SignatureAuthority.Collective13]: i18n.t('pb.safedepositbox.signatureauthority.collective', { count: 13 }),
  [SignatureAuthority.Collective14]: i18n.t('pb.safedepositbox.signatureauthority.collective', { count: 14 }),
  [SignatureAuthority.Collective15]: i18n.t('pb.safedepositbox.signatureauthority.collective', { count: 15 }),
  [SignatureAuthority.Collective16]: i18n.t('pb.safedepositbox.signatureauthority.collective', { count: 16 }),
  [SignatureAuthority.Collective17]: i18n.t('pb.safedepositbox.signatureauthority.collective', { count: 17 }),
  [SignatureAuthority.Collective18]: i18n.t('pb.safedepositbox.signatureauthority.collective', { count: 18 }),
  [SignatureAuthority.Collective19]: i18n.t('pb.safedepositbox.signatureauthority.collective', { count: 19 }),
  [SignatureAuthority.Collective20]: i18n.t('pb.safedepositbox.signatureauthority.collective', { count: 20 }),
  [SignatureAuthority.SpecialSeeDocuments]: i18n.t('pb.safedepositbox.signatureauthority.specialseedocuments'),
  [SignatureAuthority.NoSignatureRights]: 'No signature rights',
};

export const signatureAuthorityLabel = (value: unknown): string | undefined =>
  typeof value === 'string' ? signatureAuthorityLabels[value as SignatureAuthority] : undefined;

export const safeDepositBoxServiceRoleColumns: ColDef<ServiceRole>[] = [
  {
    headerName: 'Type',
    valueGetter: ({ data }) => (data?.partnerType ? partnerTypeLabels[data.partnerType] : undefined) ?? '-',
    sortable: true,
    resizable: true,
    filter: false,
    flex: 1,
    minWidth: 110,
  },
  {
    headerName: 'Safe role',
    valueGetter: ({ data }) => {
      const properties = data?.productSpecificProperties;
      return (isSafeDepositBoxServiceRoleProperties(properties) ? properties.safeRole : undefined) ?? '-';
    },
    sortable: true,
    resizable: true,
    filter: false,
    flex: 1,
    minWidth: 140,
  },
  {
    headerName: 'Signature authority',
    valueGetter: ({ data }) => {
      const properties = data?.productSpecificProperties;
      const signatureAuthority = isSafeDepositBoxServiceRoleProperties(properties)
        ? properties.signatureAuthority
        : undefined;
      return signatureAuthorityLabel(signatureAuthority) ?? '-';
    },
    sortable: true,
    resizable: true,
    filter: false,
    flex: 1,
    minWidth: 160,
  },
];
